import { render, staticRenderFns } from "./osearch.vue?vue&type=template&id=0d8f7a75&scoped=true"
import script from "./osearch.vue?vue&type=script&lang=js"
export * from "./osearch.vue?vue&type=script&lang=js"
import style0 from "./osearch.vue?vue&type=style&index=0&id=0d8f7a75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f7a75",
  null
  
)

export default component.exports